module.exports = __webpack_public_path__ + "assets/user.df537c03.svg";